import React from 'react';

function Portfolio() {
  return (
    <section className="work-minimal section-padding pb-0">
      <div className="container mt-100">
        <div className="row">
          <div className="col-12">
            <div className="sec-head mb-80">
              <div className="text">
                <h1 className="fz-80">
                  Crafting digital products,
                  <span className="opacity-7 d-block">brands & experience</span>
                </h1>
              </div>
            </div>
          </div>
        </div>
        <div className="gallery2 row stand-marg">
          <div className="col-lg-6 items">
            <div className="item mt-40">
              <div className="img">
                <img src="/dark/assets/imgs/works/4/h1.jpg" alt="" />
                <div className="cont d-flex align-items-center">
                  <div>
                    <h5>
                      <a href="/dark/project1">Nice guy with a smile</a>
                    </h5>
                  </div>
                  <div className="ml-auto">
                    <p>
                      <a href="/dark/portfolio-metro">Graphic Designing</a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-3 items width2">
            <div className="item mt-40">
              <div className="img">
                <img src="/dark/assets/imgs/works/4/1.jpg" alt="" />
                <div className="cont">
                  <h5>
                    <a href="/dark/project2">A Nice guy</a>
                  </h5>
                  <p>
                    <a href="/dark/portfolio-metro">Graphic Design</a>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-3 items width2">
            <div className="item mt-40">
              <div className="img">
                <img src="/dark/assets/imgs/works/4/2.jpg" alt="" />
                <div className="cont">
                  <h5>
                    <a href="/dark/project3">A Nice guy</a>
                  </h5>
                  <p>
                    <a href="/dark/portfolio-metro">Graphic Design</a>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-3 items width2">
            <div className="item mt-40">
              <div className="img">
                <img src="/dark/assets/imgs/works/4/3.jpg" alt="" />
                <div className="cont">
                  <h5>
                    <a href="/dark/project4">A Nice guy</a>
                  </h5>
                  <p>
                    <a href="/dark/portfolio-metro">Graphic Design</a>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-3 items width2">
            <div className="item mt-40">
              <div className="img">
                <img src="/dark/assets/imgs/works/4/4.jpg" alt="" />
                <div className="cont">
                  <h5>
                    <a href="/dark/project6">A Nice guy</a>
                  </h5>
                  <p>
                    <a href="/dark/portfolio-metro">Graphic Design</a>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6 items">
            <div className="item mt-40">
              <div className="img">
                <img src="/dark/assets/imgs/works/4/h2.jpg" alt="" />
                <div className="cont d-flex align-items-center">
                  <div>
                    <h5>
                      <a href="/dark/project3">Nice guy with a smile</a>
                    </h5>
                  </div>
                  <div className="ml-auto">
                    <p>
                      <a href="/dark/portfolio-metro">Graphic Designing</a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6 items">
            <div className="item mt-40">
              <div className="img">
                <img src="/dark/assets/imgs/works/4/h3.jpg" alt="" />
                <div className="cont d-flex align-items-center">
                  <div>
                    <h5>
                      <a href="/dark/project4">Nice guy with a smile</a>
                    </h5>
                  </div>
                  <div className="ml-auto">
                    <p>
                      <a href="/dark/portfolio-metro">Graphic Designing</a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6 items">
            <div className="item mt-40">
              <div className="img">
                <img src="/dark/assets/imgs/works/4/h4.jpg" alt="" />
                <div className="cont d-flex align-items-center">
                  <div>
                    <h5>
                      <a href="/dark/project5">Nice guy with a smile</a>
                    </h5>
                  </div>
                  <div className="ml-auto">
                    <p>
                      <a href="/dark/portfolio-metro">Graphic Designing</a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Portfolio;
